<template>
  <div class="cta-bottom">
    <img src="/static/img/toppage/lp/ctaBottom.png" alt="メールアドレス、パスワード1分で簡単登録!">
    <link-button :link="link" @click="$emit('link')" class="btn1" />
  </div>
</template>

<script>
import LinkButton from '@/utvStore/components/partials/LinkButton'

export default {
  name: 'CtaBottom',
  components: {
    LinkButton
  },
  props: {
    link: String,
    require: true,
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../sass/commons/commonVariables.scss";

.cta-bottom {
  position: relative;
  > img {
    max-width: 100%;
    vertical-align: middle;
  }
  .btn1 {
    position: absolute;
    top: 54.356%;
    left: 11.733%;
    right: 11.733%;
    width: auto;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Toppage/section/CtaBottom.vue